<template>
  <div class="ma-2 pa-1 h-100">
    <!-- <v-breadcrumbs
      class="my-7 text-h6"
      :items="['Reports', 'Agents Performance']"
    >
      <template v-slot:prepend>
        <v-icon size="small" icon="mdi-file-document"></v-icon>
      </template>
    </v-breadcrumbs> -->
    <page-title
      :titles="[$t('layouts.Reports'), $t('layouts.Agent_Performance')]"
      :icon="'mdi-file-chart-outline'"
    />
    <reports-filters
      :showAgentStatus="true"
      :showAgent="true"
      :agents="agents"
      @submitReport="getPerformanceResult"
    ></reports-filters>
    <!-- <div class="d-flex justify-end mr-3" v-if="showCount">
      <v-chip outlined label class="bg-blue-darken-2 text-white text-center">
        {{ count }} Agents
      </v-chip>
    </div> -->
    <v-sheet
      style="
        width: 98%;
        border-top-left-radius: 0.5rem;
        border-top-right-radius: 0.5rem;
      "
      class="d-flex mb-1 bg-cyan-darken-4 mr-3"
    >
      <div class="ma-2 pa-2 me-auto font-weight-bold" style="font-size: 16px">
        <span> {{ $t("reports.agent_performance_report.title") }}</span>
      </div>
      <div ref="count" class="ma-2 pa-2" v-if="showCount">
        <span>
          {{
            currentLocal == "ar"
              ? $t(getArabicPluralKey("plural.agent", count), count)
              : $t("reports.agent_performance_report.agents_count", count)
          }}</span
        >
      </div>
    </v-sheet>
    <report-progress :showProgress="showProgress" />
    <div class="ma-3">
      <v-table :hover="true" height="100%" class="my-table mt-1">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="bg-cyan-darken-4 set-border">
                {{ $t("reports.agent_performance_report.head_agent") }}
              </th>
              <th class="bg-cyan-darken-4 set-border">
                {{ $t("reports.agent_performance_report.head_name") }}
              </th>
              <th class="bg-cyan-darken-4 set-border">
                {{ $t("reports.agent_performance_report.head_received_calls") }}
              </th>
              <th class="bg-cyan-darken-4 set-border">
                {{ $t("reports.agent_performance_report.head_answered_calls") }}
              </th>
              <th class="bg-cyan-darken-4 set-border">
                {{ $t("reports.agent_performance_report.head_answered_rate") }}
              </th>
              <th class="bg-cyan-darken-4 set-border">
                {{
                  $t("reports.agent_performance_report.head_abandoned_calls")
                }}
              </th>
              <th class="bg-cyan-darken-4 set-border">
                {{ $t("reports.agent_performance_report.head_avg_duration") }}
              </th>
              <th class="bg-cyan-darken-4 set-border">
                {{ $t("reports.agent_performance_report.head_min_duration") }}
              </th>
              <th class="bg-cyan-darken-4 set-border">
                {{ $t("reports.agent_performance_report.head_max_duration") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="agent in agentPers" :key="agent.agent">
              <td class="set-border bg-teal">
                {{ agent.agent }}
              </td>
              <td class="set-border bg-grey-lighten-4 text-grey-darken-1">
                {{ agent.fullname }}
              </td>
              <td class="set-border bg-grey-lighten-4 text-cyan">
                {{ agent.received }}
              </td>
              <td
                :class="
                  'set-border bg-grey-lighten-4 text-uppercase pa-1 text-' +
                  performanceState(agent.answered, true)
                "
              >
                {{ agent.answered }}
              </td>
              <td
                :class="
                  'set-border bg-grey-lighten-4 text-uppercase pa-1 text-' +
                  performanceState(agent.answered, true)
                "
              >
                {{ agent.ansRate }}
              </td>
              <td
                :class="
                  'set-border bg-grey-lighten-4 text-uppercase pa-1 text-' +
                  performanceState(agent.dropped, false)
                "
              >
                {{ agent.lost }}
              </td>
              <td class="set-border bg-grey-lighten-4 text-indigo">
                {{ agent.avgTalkTime }}
              </td>
              <td class="set-border bg-grey-lighten-4 text-grey-darken-1">
                {{ agent.minTalkTime }}
              </td>
              <td class="set-border bg-grey-lighten-4 text-grey-darken-1">
                {{ agent.maxTalkTime }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-table>
    </div>
    <div class="text-center">
      <v-pagination
        v-model="page"
        class="my-4"
        :length="paginationLength"
        :total-visible="7"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import ReportsFilters from "../../components/ReportsFilters.vue";
import ReportProgress from "../../components/ReportProgress.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "call-report",
  data() {
    return {
      count: 0,
      showProgress: false,
      filters: null,
      page: 1,
      showCount: false,
      agents: [],
      paginationLength: 1,
      agentPers: [],
      isSubmit: false,
    };
  },
  components: {
    ReportsFilters,
    ReportProgress,
  },
  methods: {
    ...mapActions([
      "GetAgentPerformance",
      "GetUsers",
      "ShowProgressBar",
      "SetMessageDialog",
    ]),
    randomId() {
      return Math.floor(Math.random() * 90000) + 10000;
    },
    toArabicNumerals(num) {
      return num
        .toString()
        .replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d])
        .replace(/\./g, "٫");
    },
    async getPerformanceResult(sentFilters) {
      let payload = {
        from: sentFilters.from,
        to: sentFilters.to,
        agentStatus:
          sentFilters.agentStatus == "All" ? "0" : sentFilters.agentStatus,
        agent: sentFilters.agent == "All" ? "0" : sentFilters.agent,
        export: sentFilters.export,
      };
      // console.log("My payload performance", payload);
      this.filters = payload;
      await this.getPageData(true);
    },
    async initReportPage() {
      this.ShowProgressBar({ show: true, message: "Processing....." });
      var resp = await this.GetUsers({
        limit: 0,
        offset: 0,
        type: 0,
        status: 0,
        valid: 2,
      });
      this.ShowProgressBar({ show: false, message: "" });
      if (!resp.success) {
        this.SetMessageDialog({
          success: false,
          show: true,
          message: resp.message,
        });
      } else {
        this.users.forEach((user) => {
          this.agents.push(user.uname);
        });
      }
    },
    async getPageData(newSubmit) {
      this.showProgress = true;
      this.isSubmit = newSubmit;
      // console.log("Pressed in reports page");
      try {
        var resp = await this.GetAgentPerformance(this.filters);
        this.isSubmit = false;
        this.showProgress = false;

        if (!this.filters.export || resp)
          if (!resp.success) {
            this.SetMessageDialog({ show: true, message: resp.message });
          } else {
            this.agentPers = resp.records;
            this.count = resp.records.length;
            this.showCount = true;
            // this.setPaginations();
            // this.showProgress = false;
          }
      } catch (err) {
        let message = err.message;
        if (err.response) {
          message = err.response.data.message;
        }
        this.showProgress = false;
        this.SetMessageDialog({ show: true, message: message });
      }
    },
    percentage(value, total) {
      if (total === 0) {
        return 0 + "٪";
      } else if (total > 0) {
        let perct = (value / total) * 100;
        return (Math.round(perct * 100) / 100).toFixed(2) + "٪";
      }
    },
    performanceState(stats, isSuccess) {
      if (!stats > 0) {
        return "grey-darken-1";
      }
      if (isSuccess) {
        return "success";
      } else {
        return "error";
      }
    },
  },
  computed: {
    ...mapGetters(["users", "pageLimit", "domain"]),
    currentLocal() {
      return this.$vuetify.locale.current;
    },
  },
  watch: {
    async domain(newValue) {
      // console.log("My domain change: ", newValue);
      if (newValue) {
        await this.initReportPage();
      }
    },
    async page() {
      if (!this.isSubmit) {
        // console.log("My page value: ", newValue);
        this.filters.export = false;
        await this.getPageData();
      }
    },
  },
  async mounted() {
    if (this.domain) {
      await this.initReportPage();
    }
  },
};
</script>
